import { markRaw } from 'vue';
import Block from './Block';
import Seat from './Seat';

export default class Group {
  constructor(model, state, validator, watcher) {
    this.id        = model.id;
    this.state     = state;
    this.validator = validator;
    this._blocks   = null;

    const seats = model.seats.map(model => {
      const seat = new Seat(model, this, watcher);
      return this.state.seats[seat.id] = markRaw(seat);
    });

    this.seats = seats;
  }

  get blocks() {
    if (!this._blocks) this.setup();
    return this._blocks;
  }

  set blocks(value) {
    this._blocks = value;
  }

  setup() {
    let block = [];
    let blocks = [];
    let prevCategory;
    let prevStatus;
    let prevIndex;

    // Sort seats by index asc
    const seats = this.seats.sort((a, b) =>
      a.index - b.index
    );

    const commit = () => {
      if (block.length)
        blocks.push(new Block(blocks.length, block, prevStatus, this));

      block = [];
    }

    const status = seat => {
      if (this.state.selected.includes(seat.id))
        return 'selected';

      return seat.state.blocked ? 'blocked' : 'empty';
    }

    seats.forEach(seat => {
      seat.status = status(seat);

      if (
        seat.category !== prevCategory || // Create a new block when the category changes
        seat.status !== prevStatus ||
        seat.index - prevIndex > 1
      )
        commit();

      block.push(seat);

      prevCategory = seat.category;
      prevStatus = seat.status;
      prevIndex = seat.index;
    });

    commit();

    this.blocks = blocks;
  }

  flush() {
    this.blocks = null;
  }

  toggle(seat) {
    const index = this.state.selected.indexOf(seat.id);

    if (index === -1)
      this.state.selected.push(seat.id);
    else
      this.state.selected.splice(index, 1);
  }

  select(seat) {
    const index = this.state.selected.indexOf(seat.id);

    if (index === -1)
      this.state.selected.push(seat.id);
  }

  deselect(seat) {
    const index = this.state.selected.indexOf(seat.id);

    if (index !== -1)
      this.state.selected.splice(index, 1);
  }
}
